// extracted by mini-css-extract-plugin
export default {"testimonials":"testimonials_testimonials__TEPOK","stars":"testimonials_stars__PuRpE","carousel":"testimonials_carousel__9-Jn7"};